import Box from '@mui/material/Box';
import { FC } from 'react';

import { useConfigContext } from '../context/ConfigContext';
import {
  SX_MENU,
  SX_ROUTE_LEFT,
  SX_ROUTE_RIGHT,
  SX_SUBMENU,
  SX_SUBMENU_RIGHT,
} from '../utils/desktop-menu';
import DesktopList from './DesktopMenuList';

const DesktopMenu: FC = () => {
  const { menu } = useConfigContext();

  const items = menu.filter(item => item.showDesktop !== false);
  const countLeft = Math.ceil(items.length / 2);
  const left = items.slice(0, countLeft);
  const right = items.slice(countLeft);

  return (
    <Box sx={SX_MENU}>
      <Box sx={SX_SUBMENU}>
        <DesktopList items={left} sx={SX_ROUTE_LEFT} />
      </Box>
      <Box sx={SX_SUBMENU_RIGHT}>
        <DesktopList items={right} sx={SX_ROUTE_RIGHT} />
      </Box>
    </Box>
  );
};

export default DesktopMenu;
